import { render, staticRenderFns } from "./KvSuggestor.vue?vue&type=template&id=2d2bb728&"
import script from "./KvSuggestor.vue?vue&type=script&lang=js&"
export * from "./KvSuggestor.vue?vue&type=script&lang=js&"
import style0 from "./KvSuggestor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports